import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

import { ref, getCurrentInstance } from 'vue'
import { getChannelList } from '@/apis/channel'
import { ChannelM } from '@/models/channel'


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectChannel',
  props: {
    // 根据哪个属性进行搜索：id, channel_no, channel_name 
    defaultKey: {
        type: String,
        default: 'channel_no'
    },
    // 样式类
    classNames: {
        type: Array,
        default: ['filter-item']
    },
    // 默认值
    defaultVal: {
        type: String || Number,
        default: ''
    },
    // 是否可筛选
    filterable: {
        type: Boolean,
        default: true
    },
    // 是否可清空
    clearable: {
        type: Boolean,
        default: true
    },
    multiple: {     // 是否可多选
        type: Boolean,
        default: false
    },
},
  emits: ['channelChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const proxy = getCurrentInstance() as any
const emits = __emit
const props = __props

const selectedVal = ref(props.defaultVal)
const channelList = ref<ChannelM[]>([])
const onGetChannelList = async () => {
    const {code, data, msg} = await getChannelList() as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    channelList.value = data
}
onGetChannelList()

// 品牌变化，通过父组件
const onChannelChange = () => {
    const selected = channelList.value.find((item:ChannelM) => item[props.defaultKey] == selectedVal.value)
    emits('channelChange', selected)
}

// 清空选中项
const clearVal = () => {
    selectedVal.value = ''
}

// 暴露方法
__expose({
    clearVal
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (__props.defaultKey === 'channel_no')
    ? (_openBlock(), _createBlock(_component_el_select, {
        key: 0,
        multiple: __props.multiple,
        class: _normalizeClass(__props.classNames),
        modelValue: selectedVal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedVal).value = $event)),
        filterable: __props.filterable,
        clearable: __props.clearable,
        placeholder: "请选择渠道",
        onChange: onChannelChange
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.channel_name,
              value: item.channel_no
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["multiple", "class", "modelValue", "filterable", "clearable"]))
    : (__props.defaultKey === 'id')
      ? (_openBlock(), _createBlock(_component_el_select, {
          key: 1,
          multiple: __props.multiple,
          class: _normalizeClass(__props.classNames),
          modelValue: selectedVal.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedVal).value = $event)),
          filterable: __props.filterable,
          clearable: __props.clearable,
          placeholder: "请选择渠道",
          onChange: onChannelChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.channel_name,
                value: item.id + ''
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["multiple", "class", "modelValue", "filterable", "clearable"]))
      : (_openBlock(), _createBlock(_component_el_select, {
          key: 2,
          class: _normalizeClass(__props.classNames),
          multiple: __props.multiple,
          modelValue: selectedVal.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedVal).value = $event)),
          filterable: __props.filterable,
          clearable: __props.clearable,
          placeholder: "请选择渠道",
          onChange: onChannelChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(channelList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.channel_name,
                value: item.channel_name
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["class", "multiple", "modelValue", "filterable", "clearable"]))
}
}

})